<app-header></app-header>
<section class="container-fluid mb-5">
  <div class="initiale_sestion">
    <div class="dFlex">
      <div class="head">
        <h4 class="form-title-sm">{{'Notifications' | translate}}</h4>
      </div>
      <div class="search" (click)="showSearch()">
        <div class="a">
          <input type="text" placeholder="{{'Search' | translate}}" id="searchInput" (keyup)="setFilteredNotification($event)" (keydown)="setFilteredNotification($event)">
          <div id="searchStyle">
            <i class="fa-solid fa-magnifying-glass"></i><small>{{'Search' | translate}}</small>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="notification_section mt-4">
    <!-- 
                    class
                    Rejected == For rejected 
                    Read === For already clicked notifications
                 -->
    <div *ngFor="let notificationlist of notificationDetails;">
      <div *ngIf="notificationlist.push == 0" class="cardStyle col_1 {{ notificationlist.class }}" [ngClass]="{'notification-viewed': notificationlist.view_status == 1}">
        <div class="logo">
          <img src="assets/images/business_logo.png" alt="" class="img-fluid">
        </div>
        <div>
          <h5>{{ notificationlist.title }}</h5>
          <p>{{ notificationlist.message }}</p>
        </div>
        <div class="date">
          <span>{{notificationlist.datetime }}</span>
        </div>
      </div>
      <div *ngIf="notificationlist.push == 1" class="cardStyle push-notification col_1" [ngClass]="{'notification-viewed': notificationlist.view_status == 1}" (click)="goToView(notificationlist.landing_page, notificationlist.push_ids)">
        <div class="logo">
          <img src="assets/images/business_logo.png" alt="" class="img-fluid">
        </div>
        <div>
          <h5>{{ notificationlist.title }}</h5>
          <p>{{ notificationlist.push_message}}</p>
        </div>
        <div class="date">
          <span>{{notificationlist.datetime }}</span>
        </div>
      </div>
    </div>
  </div>
  <h5 *ngIf="notificationDetails && notificationDetails.length == '0'"> {{'No Messages' | translate}}</h5>
</section>
<div *ngIf="!notificationDetails" id="employee-nolist">
  <div class="image-container col-sm-12">
    <img src="assets/images/employee_nolist.png">
  </div>
  <div class="text-container text-center">
    <h3 class="mt-4">{{'No Notifications.' | translate}}</h3>
  </div>
</div>
<app-footer></app-footer>
<app-contact-floating></app-contact-floating>
